export default {
      id: "spinner-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "sprite-46b249.svg#spinner-usage",
      toString: function () {
        return this.url;
      }
    }